// ----------------------------------------------------------------------

export default function InputLabel(theme, read) {
  return {
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: `${theme.palette.text.primary} !important`,
        },
      },
    },
  };
}
